import { ImageUploadImageSetModel } from '../image-admin/image-models/image-upload-image-set.model';

export class ProdcutImageUtil {
  public mapImages(className, iscommercial: string | boolean, uploadImageSetModels: ImageUploadImageSetModel[], currentSet: ImageUploadImageSetModel): ImageUploadImageSetModel {
    if (iscommercial === true || iscommercial === 'true') {
      // fixed for case-insensitive substring match on 'commercial' as well as simultaneous inclusion of 'both' and null
      const comImages = uploadImageSetModels.filter(i => i.line == null || i.line.toLowerCase().includes('commercial') || i.line.toLowerCase().includes('both'));
      return this.getClassMap(currentSet, comImages, className);
    } else {
      // fixed for case-insensitive substring match on 'residential' as well as simultaneous inclusion of 'both' and null
      const resImages = uploadImageSetModels.filter(i => i.line == null || i.line.toLowerCase().includes('residential') || i.line.toLowerCase().includes('both'));
      return this.getClassMap(currentSet, resImages, className);
    }
  }

  public getImagesSets(className, iscommercial, uploadImageSetModels: ImageUploadImageSetModel[]): ImageUploadImageSetModel[] {
    let matching: ImageUploadImageSetModel[] = [];

    if (iscommercial === 'true') {
      const comImages = uploadImageSetModels.filter(i => i.line == null || i.line.toLowerCase().includes('commercial') || i.line.toLowerCase().includes('both'));

      if (comImages && comImages.length > 0) {

        matching = matching.concat(comImages);
      
      } else if (uploadImageSetModels.filter(i => i.line === 'Both' || i.line == null).length > 0) {

        const bothLineImages = uploadImageSetModels.filter(i => i.line === 'Both' || i.line == null);
        matching = matching.concat(bothLineImages);
      
      }
    } else {

      const resImages = uploadImageSetModels.filter(i => i.line == null || i.line.toLowerCase().includes('residential') || i.line.toLowerCase().includes('both'));

      if (resImages && resImages.length > 0) {

        matching = matching.concat(resImages);

      } else if (uploadImageSetModels.filter(i => i.line === 'Both' || i.line == null).length > 0) {

        const bothLineImages = uploadImageSetModels.filter(i => i.line === 'Both' || i.line == null);
        matching = matching.concat(bothLineImages);

      }
    }
    return matching;
  }

  public getImagesForClass(comImages: ImageUploadImageSetModel[], className: string): ImageUploadImageSetModel[] {
    const classImages = comImages.filter(i => i.class === className);
    const matching: ImageUploadImageSetModel[] = [];
    if (classImages && classImages.length > 0) {
      // Perfect Match use this one!
      for (const image of classImages) {
        matching.push(image);
      }
    } else {
      // get the default image for the line
      const defaultComImage = comImages.filter(i => !i.class || i.class === 'All');
      if (defaultComImage && defaultComImage.length > 0) {
        for (const image of defaultComImage) {
          matching.push(image);
        }
      }
    }
    return matching;
  }

  public getClassMap(currentSet: ImageUploadImageSetModel, comImages: ImageUploadImageSetModel[], className: string): ImageUploadImageSetModel {
    const classImages = comImages.filter(i => i.class === className);
    if (classImages && classImages.length > 0) {
      // Perfect Match use this one!
      return this.mapUrls(currentSet, classImages[0]);
    } else {
      // get the default image for the line
      const defaultComImage = comImages.filter(i => !i.class || i.class === 'All');
      if (defaultComImage && defaultComImage.length > 0) {
        return this.mapUrls(currentSet, defaultComImage[0]);
      } else {
        // should not have gotten here but map the first Commercial image just in case
        console.log(`image for class ${className} not found`);
        this.mapUrls(currentSet, comImages[0]);
      }
    }
  }

  public translateClassName(iscommercial: string, classDisplayName: string): string {
    if (iscommercial === 'true') {
      switch (classDisplayName) {
        case 'Outdoor Units':
        case 'Indoor Units':
        case 'Controls':
        case 'Accessories':
        case 'Air Technologies':
        case 'Chillers':
          return 'Multi V';

        default:
          return classDisplayName;
      }
    } else {
      switch (classDisplayName) {
        case 'Single Zone':
          return 'Single Zone';

        case 'Multi Zone Indoor':
        case 'Multi Zone Outdoor':
        case 'Controls':
        case 'Accessories':
        case 'Water Heating':
        case 'Air Technologies':
          return 'Multi Zone';

        case 'PTAC':
          return 'PTAC';

        default:
          return classDisplayName;
      }
    }
  }

  public mapUrls(currentSet: ImageUploadImageSetModel, selectedSet: ImageUploadImageSetModel): ImageUploadImageSetModel {
    currentSet.highresimage = selectedSet.highresimage;
    currentSet.desktoplargeimage = selectedSet.desktoplargeimage;
    currentSet.desktopsmallimage = selectedSet.desktopsmallimage;
    currentSet.tabletimage = selectedSet.tabletimage;
    currentSet.phoneimage = selectedSet.phoneimage;
    return selectedSet;
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/product-image-util.ts